module.exports = __webpack_public_path__ + "static/Recording_rules_2-e6a0524db016b3d66a822bc7c8694fea.webm";